module.exports = __webpack_public_path__ + "static/media/Bytt-tutorial-1.b9d4ba7b.mp3";